export enum ProductCode {
  EzyMedical = 'OPCM_P',
  iMedicalCard = 'OPTM_P',
  EasyHealth = 'OPCM_H',
}
